
/**
 * Banner selection Enum.
 */
export enum BannerSelectorMobile {
  en = 'restaurantAdBannerEggMobileEn',
  jp = 'restaurantAdBannerEggMobileJp',
}
